import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bc420a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "page mt30" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row1" }, "Roxe documents"),
  /*#__PURE__*/_createElementVNode("div", { class: "row2" }, "Download")
], -1))
const _hoisted_5 = { class: "tb" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row1 blue" }, "RISN rule book", -1))
const _hoisted_7 = { class: "tb" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row1 blue" }, "Roxe payment acquiring API", -1))
const _hoisted_9 = { class: "tb" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row1 blue" }, "RISN Transaction Service API", -1))
const _hoisted_11 = { class: "tb" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row1 blue" }, "RISN Message Network API(ISO20022)", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Please input invitation code!", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button" }, "Continue", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_r_icon = _resolveComponent("r-icon")!
  const _component_Tail = _resolveComponent("Tail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "white" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showme && _ctx.showme(...args))),
          class: "row2"
        }, [
          _createVNode(_component_r_icon, {
            class: "mr20",
            icon: "u14",
            size: 25
          }),
          _createVNode(_component_r_icon, {
            icon: "u15",
            size: 25
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showme && _ctx.showme(...args))),
          class: "row2"
        }, [
          _createVNode(_component_r_icon, {
            class: "mr20",
            icon: "u14",
            size: 25
          }),
          _createVNode(_component_r_icon, {
            icon: "u15",
            size: 25
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showme && _ctx.showme(...args))),
          class: "row2"
        }, [
          _createVNode(_component_r_icon, {
            class: "mr20",
            icon: "u14",
            size: 25
          }),
          _createVNode(_component_r_icon, {
            icon: "u15",
            size: 25
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showme && _ctx.showme(...args))),
          class: "row2"
        }, [
          _createVNode(_component_r_icon, {
            class: "mr20",
            icon: "u14",
            size: 25
          }),
          _createVNode(_component_r_icon, {
            icon: "u15",
            size: 25
          })
        ])
      ]),
      _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeme && _ctx.closeme(...args))),
        class: _normalizeClass(['pop',_ctx.hide?'hide':''])
      }, [
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args))),
          class: "dialog"
        }, _hoisted_16)
      ], 2)
    ]),
    _createVNode(_component_Tail)
  ]))
}